import * as Sentry from "@sentry/react";
import type { ReactNode } from "react";
import { ErrorFallback } from "@/components/features/errors/ErrorFallback";

interface ErrorBoundaryProps {
  children: ReactNode;
}

/**
 * Top-level React error boundary backed by Sentry.
 *
 * Catches uncaught render / effect / handler errors anywhere in the tree,
 * reports them to Sentry with component stack, and renders a Cyphron-branded
 * `ErrorFallback` (UI-SPEC §Flow C).
 *
 * Placed inside `<BrowserRouter>` so that "Tentar novamente" / "Voltar ao início"
 * can trigger real navigation via the router context.
 */
export function ErrorBoundary({ children }: ErrorBoundaryProps) {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error, eventId, resetError }) => (
        <ErrorFallback
          error={error as Error}
          eventId={eventId}
          resetError={resetError}
        />
      )}
      showDialog={false}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
